export const ENABLE_RTL_SUPPORT = "shared/RtlSupport/ENABLE_RTL_SUPPORT";
